import React from 'react';
import "./Icons.css"
 const Icon = () => {
  return (
  <div className='icon'>
    <div className='icon-image'>
    <img src="https://img.icons8.com/color/48/000000/facebook-messenger--v1.png" alt = "messenger"/>
    </div>
    <div className='icon-title'>
      <p> <b>QuickChat</b></p>
    </div>

  </div>);
};

export default Icon
